import { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "aimploy_cookie_consent_v1";

export default function CookieBanner() {
    const [visible, setVisible] = useState(() => {
        if (typeof window === "undefined") return false;
        try {
            return !localStorage.getItem(STORAGE_KEY);
        } catch {
            return false;
        }
    });

    const accept = () => {
        try {
            localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({ necessary: true, accepted_at: new Date().toISOString() }),
            );
        } catch {}
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-4 left-4 right-4 lg:left-auto lg:right-6 lg:bottom-6 z-[70] max-w-md"
        >
            <div className="bg-aimploy-dark text-white rounded-2xl p-5 lg:p-6 shadow-[0_20px_60px_rgba(0,0,0,0.4)] border border-white/10">
                <div className="flex items-start gap-3 mb-3">
                    <div className="h-9 w-9 rounded-lg bg-aimploy-violet/20 text-aimploy-violet flex items-center justify-center flex-shrink-0">
                        <Cookie className="w-4 h-4" />
                    </div>
                    <div className="min-w-0">
                        <div className="font-display font-bold text-base mb-1">Cookies & Datenschutz</div>
                        <p className="text-xs text-white/70 leading-relaxed">
                            Wir nutzen ausschließlich technisch notwendige Cookies für den Betrieb der Website (z. B. Login,
                            Formular-Sicherheit). Es findet kein Tracking, keine Analyse und kein Marketing statt.
                            Mehr unter{" "}
                            <Link
                                to="/datenschutz"
                                target="_blank"
                                className="text-aimploy-violet underline hover:no-underline"
                                data-testid="cookie-banner-privacy-link"
                            >
                                Datenschutz
                            </Link>
                            .
                        </p>
                    </div>
                </div>
                <button
                    onClick={accept}
                    data-testid="cookie-banner-accept"
                    className="w-full bg-aimploy-violet hover:bg-aimploy-violet-hover text-white rounded-xl py-2.5 text-sm font-semibold transition-colors"
                >
                    Verstanden
                </button>
            </div>
        </div>
    );
}
